<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.create')} ${$t('warehouse.department')}`
          : `${$t('common.edit')} ${$t('warehouse.department')}`
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.name')" label-for="name">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
              <p class="text-danger mt-1">{{ errorForm.name }}</p>
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group
              :label="$t('common.description')"
              label-for="description"
            >
              <b-form-input
                v-model="EditForm.description"
                :placeholder="$t('common.description')"
              />
              <p class="text-danger mt-1">{{ errorForm.description }}</p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitDepartment"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.submit") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>

    <b-card :title="$t('warehouse.department')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("common.filter") }} {{ $t("warehouse.department") }}</h2>
            <br />
          </b-col>
          <b-col cols="4">
            <AutoComplete
              :label="$t('warehouse.department')"
              :placeholder="`${$t('common.select')} ${$t(
                'warehouse.department'
              )}`"
              v-model="department_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="departments"
              text-title="name"
            />
          </b-col>
        </b-row>
        <div class="d-flex align-items-center justify-content-end mt-1">
          <b-button variant="primary" @click="getDepartmentList()">
            {{ $t("common.search") }}
          </b-button>
        </div>

        <!-- Search Button -->

        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("common.table") }} {{ $t("warehouse.department") }}</h2>
          <b-button variant="primary" @click="show(null, 'create')">
            {{ $t("common.create") }} {{ $t("warehouse.department") }}
          </b-button>
        </div>

        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(created_at)="data">
            <span
              style="unicode-bidi: isolate"
              :style="{
                direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr',
              }"
              >{{ data.item.created_at }}</span
            >
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->
              <ActionsButtons
                deletePerm="delete-department"
                editPerm="update-department"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />

              <!-- Dropdown -->
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                {{ $t("warehouse.one-item") }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getStockInList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BCardText,
  BIconSearch,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import Datepicker from "vuejs-datepicker";
const CategoryModal = () => import("@/components/warehouse/CategoryModal.vue");
import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
export default {
  mixins: [permissionChecker],

  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BLink,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BCardText,
    BIconSearch,
    StatisticCardHorizontal,
    AutoComplete,
    Datepicker,
    CategoryModal,
    ActionsButtons,
    DeleteModal,
  },
  data() {
    return {
      take: 10,
      loading: true,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        description: "",
        _method: "POST",
      },
      createMode: false,
      errorForm: {
        name: "",
        description: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "name", label: this.$t("common.name"), sortable: true },
        {
          key: "description",
          label: this.$t("common.description"),
          sortable: true,
        },
        {
          key: "created_at",
          label: this.$t("common.date"),
          sortable: true,
        },

        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      department_id: null,
    };
  },
  mounted() {
    this.getDepartmentList();
  },
  methods: {
    otherQuerywearhouseStokc() {
      return `filter[type]=${
        this.$route.name.includes("pharmacy") ? "pharmacy" : "hospital"
      }`;
    },
    assignCategoryFilter(v) {
      this.categoryFilter = v;
    },
    show(item, mode) {
      console.log("item", item);
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          name: "",
          description: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.name = item.name;
        this.EditForm.description = item.description;
        this.EditForm.id = item.id;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },

    async getDepartmentList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/departments?page=${this.page}&take=${this.take}&sort=-id`;

      if (this.department_id) {
        url += `&filter[id]=${this.department_id}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    async deleteItem() {
      await this.$store
        .dispatch("delete", `/departments/${this.deleteForm.id}`)
        .then((response) => {
          this.getDepartmentList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.name,
            },
          });
        });
    },
    submitDepartment() {
      this.loading = true;
      let count = 0;
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      console.log(this.EditForm);
      if (!this.EditForm.name) {
        this.errorForm.name = "Name is required";
        count++;
      }
      if (!this.EditForm.description) {
        this.errorForm.description = "Description is required";
        count++;
      }

      if (count > 0) {
        this.loading = false;
        return;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/departments`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.loading = false;
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Created",
                  variant: "success",
                },
              });
              this.getDepartmentList();
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/departments/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.loading = false;
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Updated",
                  variant: "success",
                },
              });
              this.getDepartmentList();
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
